import { render, staticRenderFns } from "./contract_old.vue?vue&type=template&id=6201c1cf&scoped=true"
import script from "./contract_old.vue?vue&type=script&lang=js"
export * from "./contract_old.vue?vue&type=script&lang=js"
import style0 from "./contract_old.vue?vue&type=style&index=0&id=6201c1cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201c1cf",
  null
  
)

export default component.exports